<template>
    <li class="product-item">
        <div class="product-cover" @click="goToProductInfo">
            <img :src="$config.QINIU_URL + productInfo.imgList[0].filePath" />
        </div>
        <div class="product-info">
            <div class="product-name" @click="goToProductInfo">
                <template v-if="Array.isArray(productInfo.labelList)">
                    <span
                        class="lable-item"
                        :key="index"
                        :style="{
                            backgroundColor: item.backgroundColor,
                            color: item.fontColor,
                        }"
                        v-for="(item, index) in productInfo.labelList"
                        >{{ item.labelName }}</span
                    >
                </template>
                <span>{{ productInfo.goodsName }}</span>
            </div>
            <div class="product-params">
                <div class="params-item" @click="goToProductInfo">
                    <span class="params-name">原厂编码</span>
                    <span
                        class="params-value"
                        v-html="productInfo.factoryCode"
                    ></span>
                </div>
                <div class="params-item" @click="goToProductInfo">
                    <span class="params-name">品牌</span>
                    <span
                        class="params-value"
                        v-html="productInfo.brandName"
                    ></span>
                </div>
                <div class="params-item" @click="goToProductInfo">
                    <span class="params-name">库存</span>
                    <span class="params-value"
                        >{{
                            productInfo.stock.qtyTotal
                                ? productInfo.stock.qtyTotal
                                : 0
                        }}&nbsp;pcs</span
                    >
                </div>
                <div class="params-item">
                    <span class="params-name">包装</span>
                    <span class="params-value"
                        >每{{ productInfo.packingUnitOuter }}&nbsp;{{
                            productInfo.packingQty
                        }}&nbsp;pcs</span
                    >
                </div>
                <div class="params-item" v-if="hasBatch">
                    <span class="params-name">批次</span>
                    <span class="params-value"
                        >{{ productInfo.stock.batchList[0].batchNo }}
                    </span>
                </div>
                <div class="params-item" v-if="!hasRelation">
                    <span class="params-relation" @click="onRelation"
                        >自定义物料编码</span
                    >
                </div>
                <div
                    class="params-item"
                    v-if="hasRelation"
                    @click="onDeleteRelation"
                >
                    <span class="params-name">自定义编码</span>
                    <span class="params-value"
                        >{{ productInfo.relation.customCode }}
                    </span>
                    <span class="params_delete_icon"></span>
                </div>
                <div class="params-item">
                    <span class="params-name"
                        >含税单价({{ $config.TAX_NUMBER }}%)</span
                    >
                </div>
            </div>
            <div class="product-price">
                <div
                    class="price-item"
                    @click="goToProductInfo"
                    v-for="(item, index) in productInfo.priceRangeList"
                    :key="index"
                >
                    <span class="pcs-number"> {{ item.qtyStart }}+ </span>
                    <span
                        class="price-number"
                        :class="{
                            'last-price':
                                index == productInfo.priceRangeList.length - 1,
                        }"
                    >
                        ¥{{ item.price }}
                    </span>
                </div>
            </div>
        </div>
        <div
            class="cart-icon"
            @click.stop="buyProduct"
            :class="{ disabled: unableBuy }"
        ></div>
    </li>
</template>
<script>
import { isEmpty } from "@/utils/validation";
export default {
    name: "ProductItem",
    props: {
        productInfo: {
            //商品信息
            type: [Object],
            required: true,
        },
    },
    data() {
        return {};
    },
    beforeUpdate() {},
    methods: {
        /**
         * @description 跳转到
         */
        goToProductInfo() {
            let { productId } = this.productInfo;
            if (isEmpty(productId)) return;
            this.$router.push({
                path: "/product/info",
                query: {
                    id: productId,
                },
            });
        },
        /**
         * @description 购买商品传递
         */
        buyProduct() {
            if (this.unableBuy) return;
            this.$emit("buy", this.productInfo);
        },
        onRelation() {
            if (!this.hasRelation) {
                this.$emit("relation", this.productInfo);
            }
        },
        onDeleteRelation() {
            this.$emit("relationDelete", this.productInfo);
        },
    },
    computed: {
        /**
         * @description 计算是否不能购买
         */
        unableBuy() {
            let { stock = {}, minPurchase } = this.productInfo;
            return stock.qtyTotal < minPurchase;
        },
        hasBatch() {
            let { batchList = [] } = this.productInfo.stock;
            return !isEmpty(batchList);
        },
        hasRelation() {
            let { relation = {} } = this.productInfo;
            return !isEmpty(relation.customCode);
        },
    },
    watch: {},
};
</script>
<style lang="less">
.product-info {
    .highLight {
        color: red !important;
    }
}
</style>
<style lang="less" scoped>
.product-item {
    overflow: hidden;
    position: relative;
    z-index: 1;
    padding: 30px 30px 20px 30px;
    width: 690px;
    margin-bottom: 10px;
    background-color: #fff;
    .product-cover {
        float: left;
        width: 120px;
        img {
            width: 120px;
        }
    }
    .product-info {
        float: right;
        width: 540px;
        .product-name {
            font-size: 28px;
            line-height: 32px;
            word-break: break-all;
            .lable-item {
                *display: inline;
                display: inline-block;
                zoom: 1;
                margin-right: 5px;
                height: 32px;
                padding: 0 15px;
                font-size: 24px;
                line-height: 32px;
            }
        }
        .product-params {
            .params-item {
                margin-bottom: 2px;
                font-size: 24px;
                line-height: 1.6;
                .params-name {
                    color: #999;
                    padding-right: 20px;
                }
                .params-relation {
                    color: #4bc227;
                }
                .params-value {
                    color: #333;
                }

                .params_delete_icon {
                    *display: inline;
                    display: inline-block;
                    vertical-align: -3px;
                    margin-left: 2px;
                    zoom: 1;
                    height: 22px;
                    width: 22px;
                    background-image: url("../../../../public/images/product/relation_delete_icon.png");
                    background-size: 22px;
                }
            }
        }
        .product-price {
            .price-item {
                margin-bottom: 2px;
                height: 40px;
                font-size: 24px;
                .pcs-number {
                    *display: inline;
                    display: inline-block;
                    zoom: 1;
                    min-width: 110px;
                }
                .price-number {
                    color: #666;
                    &.last-price {
                        color: #f50;
                    }
                }
            }
        }
    }
    .cart-icon {
        position: absolute;
        right: 30px;
        bottom: 30px;
        z-index: 2;
        width: 56px;
        height: 56px;
        background-repeat: no-repeat;
        background-image: url("../../../../public/images/product/cart-active-icon.png");
        background-position: center;
        background-size: 56px;
        &.disabled {
            background-image: url("../../../../public/images/product/cart-disabled-icon.png");
        }
    }
}
</style>
